import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@mui/styles'

import lang from '@/lang'
import Modal from '@/modules/base/components/modal/big/modal-big'
import { TaxConsultantService } from '@/modules/settings/components/tax-consultant/taxConsultantService'
import Radio from '@/modules/client/components/list/radio'
import RadioContent from '@/modules/client/components/list/radio/content'
import { ButtonIconSquare } from '@/modules/base/components/buttons'
import { CLIENT_INVITATION_STATUS } from '@/modules/client/_helpers/getStatusLabel'
import useInvites from '@/modules/client/_helpers/useInvites'

const ClientInvitationsModal = (props) => {
  const { onClose, isOpen } = props
  const [selection, setSelection] = useState([])
  const { invitingClients, isLoading } = useInvites()
  const classes = useStyles()

  const handleChange = (tenantCollaborationId) => {
    if (selection.includes(tenantCollaborationId)) {
      setSelection(selection.filter(id => id !== tenantCollaborationId))
    } else {
      setSelection(Array.from(new Set([...selection, tenantCollaborationId])))
    }
  }

  useEffect(() => {
    setSelection([])
    if (!isLoading && invitingClients.length === 0) onClose && onClose()
  }, [isLoading])

  const doClose = () => {
    onClose && onClose()
  }

  const handleAccept = () => {
    selection.forEach(async(tenantCollaborationId) => {
      try {
        await TaxConsultantService.setConnectionStatus(tenantCollaborationId, CLIENT_INVITATION_STATUS.ACCEPTED)
      } finally {
      }
    })
  }

  const handleReject = () => {
    selection.forEach(async(tenantCollaborationId) => {
      try {
        await TaxConsultantService.setConnectionStatus(tenantCollaborationId, CLIENT_INVITATION_STATUS.REJECTED)
      } finally {
      }
    })
  }

  return (
    <Modal
      disableBackdropClick
      onClose={onClose}
      open={isOpen}
      title={lang.taxConsultant.invitationsModal.heading}
      subtitle={lang.taxConsultant.invitationsModal.text}
      showCloseIcon
    >
      <div className={classes.options}>
        {
          invitingClients.length > 0 && invitingClients.map((client) => {
            const { name, email, address, tenantCollaborationId } = client

            return (
              <Radio key={`key_${tenantCollaborationId}`}
                defaultChecked={false}
                disabled={false}
                name={name + tenantCollaborationId}
                value={tenantCollaborationId}
                checked={selection.includes(tenantCollaborationId)}
                onClick={() => handleChange(tenantCollaborationId)}
              >
                <RadioContent
                  title={`${name} - ${email}`}
                  subtitle={(
                    <span>{address?.street}, {address?.zipCode} {address?.city}</span>
                  )}
                />
              </Radio>
            )
          })
        }
      </div>
      <div className={classes.buttons}>
        <ButtonIconSquare
          customClass={classes.acceptLaterButton}
          onClick={doClose}
          variant='outline'
          label={lang.taxConsultant.invitationsModal.acceptLater}
        />
        <div className={classes.buttons}>
          <ButtonIconSquare
            onClick={handleReject}
            disabled={selection.length === 0}
            variant='outline'
            label={lang.taxConsultant.invitationsModal.reject}
          />
          <ButtonIconSquare
            onClick={handleAccept}
            disabled={selection.length === 0}
            variant='fill'
            label={lang.taxConsultant.invitationsModal.accept}
          />
        </div>
      </div>
    </Modal>
  )
}

const useStyles = makeStyles((theme) => ({
  buttons: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 10,
  },
  acceptLaterButton: {
    marginBottom: 0,
    marginLeft: 0,
  },
  options: {
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 300,
    marginBottom: 20,
    overflowY: 'auto',
    gap: 10,
    '& > label': {
      marginBottom: 10,
      padding: 10,
    },
  },
}))

ClientInvitationsModal.propTypes = {
  onClose: PropTypes.func,
  isOpen: PropTypes.bool,
}

ClientInvitationsModal.defaultProps = {
  onClose: () => {},
  isOpen: false,
}

export default ClientInvitationsModal
